import React from "react";
import "./StatsBar.scss";

const stats = [
  { value: "1150+", label: "Happy Customers", icon: "bi-people" },
  { value: "150+", label: "Insurance Careers", icon: "bi-person-badge" },
  { value: "15+", label: "Awards Won", icon: "bi-award" },
  { value: "2000+", label: "Claims Settled", icon: "bi-file-earmark-check" }
];

function StatsBar() {
  return (
    <section className="stats-bar">
      <div className="container">
        <div className="row text-center">
          {stats.map(function (item, index) {
            return (
              <div className="col-6 col-md-3 stats-item" key={index}>
                <div className="d-flex">
                    <div className="pe-2"><i className={"bi " + item.icon + " stats-icon"}></i> </div>
                    <div className="ps-2 text-start">
                        <h3 className="stats-value">{item.value}</h3>
                        <p className="stats-label">{item.label}</p>
                    </div> 
                </div> 
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default StatsBar;
